import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {CardViewChildEntityListItem} from './ChildEntityListItem';
import DisplayAllItemsModal from './DisplayAllItemsModal';
import Utility from '../../../../../../../util/utilityfunctions';
import {specialBodiesSlices} from '../../../../../../../util/uiconstants';

function ChildEntityList({
	allIds,
	className,
	itemsDisplayed = 5,
	nameKey,
	selector,
	showAllLabel = 'Show all elements',
	title,
	header,
	onRemove,
	fatherId,
	childEntityId
}) {
	const [isOpen, setIsOpen] = useState(false);

	const filteredAllIds = useSelector((state) =>
		nameKey === 'itApplicationName' && Array.isArray(allIds)
			? allIds.filter((id) => !selector(state, id).isServiceOrganization)
			: allIds
	);

	const entityIds = filteredAllIds?.length > itemsDisplayed ? filteredAllIds.slice(0, itemsDisplayed) : filteredAllIds;

	let displayedIds = useSelector((state) => {
		const slice = specialBodiesSlices[childEntityId];
		let entities =  entityIds.map((id) => state.bodiesSpecial[slice]?.byId[id]);
		Utility.sortAlphaNumeric(entities, nameKey);
		return entities.map((entity) => entity.id);
	});

	return (
		<section className={`entity-list ${className}`}>
			{displayedIds?.map((id) => {
				return (
					<CardViewChildEntityListItem
						key={id}
						id={id}
						selector={selector}
						nameKey={nameKey}
						onRemove={onRemove}
						fatherId={fatherId}
					/>
				);
			})}
			{filteredAllIds?.length > itemsDisplayed && (
				<a
					className="show-all-hyperlink"
					onClick={() => {
						setIsOpen(true);
					}}
				>
					{showAllLabel}
				</a>
			)}
			{isOpen && (
				<DisplayAllItemsModal
					selector={selector}
					allIds={filteredAllIds}
					title={title}
					setIsOpen={setIsOpen}
					nameKey={nameKey}
					header={header}
					onRemove={onRemove}
					fatherId={fatherId}
					slice={specialBodiesSlices[childEntityId]}
				/>
			)}
		</section>
	);
}

ChildEntityList.propTypes = {
	itemsDisplayed: PropTypes.number,
	allIds: PropTypes.arrayOf(PropTypes.number).isRequired,
	nameKey: PropTypes.string.isRequired,
	selector: PropTypes.func.isRequired,
	showAllLabel: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	header: PropTypes.node.isRequired,
	onRemove: PropTypes.func.isRequired,
	fatherId: PropTypes.number.isRequired
};

const StyledChildEntityList = styled(ChildEntityList)`
	.entity-list {
		font-weight: normal;
	}

	a {
		font-weight: bold;
	}

	a:hover {
		cursor: pointer;
		color: var(--blue-600) !important;
	}
`;

export default StyledChildEntityList;

StyledChildEntityList.displayName = 'StyledChildEntityList';
